export const initialAbility = [
  {
    action: 'manage',
    subject: 'all'
  }
]

export const _ = undefined
